import { VAlert } from 'vuetify/lib/components/VAlert';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    VAlert,
    {
      attrs: {
        type: _vm.type,
        icon: _vm.icon,
        color: _vm.color,
        dismissible: _vm.dismissible,
        text: "",
        outlined: "",
        dense: "",
        border: "left",
      },
    },
    [_vm._v(" " + _vm._s(_vm.message) + " ")]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }